module.exports = __webpack_public_path__ + "static/media/hrpermanent-tsb.6b1b4668.png";